var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Well } from "@brushfire/ui";
var CookieWarning = function () {
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "absolute-center" }, { children: _jsx(Well, __assign({ className: "well-sm" }, { children: _jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "auth-result-dots" }, { children: _jsx(Icon, { icon: "cookie-bite", classes: "fa-3x" }) })), _jsx("div", __assign({ className: "m-top-medium" }, { children: "Third party cookies must be enabled to run this site. Please enable them and refresh your browser." }))] }) })) })) }));
};
export default CookieWarning;
